var map = {
	"./fuyuzora-melt-reply/logo.svg": 5539,
	"./fuyuzora-melt/logo.svg": 2516,
	"./hug-time/logo.svg": 427,
	"./kouen-no-maken/logo.svg": 4468,
	"./kuroda-san/logo.svg": 5428,
	"./melody/logo.svg": 8211,
	"./noroi-no-rondo/logo.svg": 4449,
	"./oshi-katsu/logo.svg": 4838,
	"./sayonara-no-mirai/logo.svg": 629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9774;